// extracted by mini-css-extract-plugin
export default {"input_wrapper":"styles_input_wrapper__alY2C","label":"styles_label__6b3m1","input":"styles_input__buHDZ","readonly":"styles_readonly__5VFOW"};